import { gql } from "@apollo/client";

export const GET_CONTRACT_TEMPLATE = gql`
  query {
    getContractTemplate {
      success
      message
      template_url
    }
  }
`;
